import { render } from "./CheckoutPage.vue?vue&type=template&id=62cef081&scoped=true"
import script from "./CheckoutPage.vue?vue&type=script&lang=js"
export * from "./CheckoutPage.vue?vue&type=script&lang=js"

import "./CheckoutPage.vue?vue&type=style&index=0&id=62cef081&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cef081"]])

export default __exports__